import React from 'react'
import styles from './OfferBanner.module.css'

const OfferBanner = ({
  title = 'Welcome Offer Used',
  text = "Your first month's 50 free minutes have been used. Calls are now billed at $0.12/min on your PAYG plan",
}) => {
  return (
    <div className={styles.banner}>
      <div className={styles.iconWrap}>
       <img src="/svg/offer_icon.svg" alt="Offer Icon" />
      </div>
      <div className={styles.textBlock}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.text}>{text}</p>
      </div>
    </div>
  )
}

export default OfferBanner
